module.exports = __webpack_public_path__ + "00b42d266012338b5ce2cf2042f1f56c.png";